<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title class="text-h6">
        Confirm Delete
      </v-card-title>
      <v-card-text>
        Are you sure you want to delete <strong>{{ item?.name }}</strong>?
        <br><br>
        This action cannot be undone.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleCancel" variant="outlined">
          Cancel
        </v-btn>
        <v-btn 
          @click="handleDelete" 
          color="error" 
          :loading="deleting"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'DeleteItemDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    deleting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'delete', 'cancel'],
  setup(props, { emit }) {
    const show = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })

    const handleDelete = () => {
      emit('delete')
    }

    const handleCancel = () => {
      emit('cancel')
    }

    return {
      show,
      handleDelete,
      handleCancel
    }
  }
}
</script>